module.exports = __webpack_public_path__ + "static/media/save.e27ab5a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/save.svg
// module id = 29
// module chunks = 0